import { mutator } from 'satcheljs';
import { discardGroupOptions } from '../actions/internalActions';
import store from '../store/store';

/**
 * Mutator that resets the GroupOptionsStore values.
 */
export default mutator(discardGroupOptions, actionMessage => {
    const groupOptionsStore = store();
    groupOptionsStore.echoGroupMessageBackToSubscribedSender = null;
});
